"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var react_feather_1 = require("react-feather");
var styled_system_1 = require("styled-system");
var ActionSheet_1 = require("./ActionSheet");
var DropdownMenu_1 = require("./DropdownMenu");
var KeyboardButton_1 = require("./KeyboardButton");
var theme_1 = require("./theme");
var UIComponents_1 = require("./UIComponents");
var utils_1 = require("./utils");
var colors_1 = require("./utils/colors");
var DropdownButton = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.shortcut, shortcut = _d === void 0 ? "" : _d, loading = _a.loading, menu = _a.menu, props = __rest(_a, ["children", "className", "variant", "size", "shortcut", "loading", "menu"]);
    var _e = (0, react_1.useState)(false), isOpen = _e[0], setOpen = _e[1];
    var isMobile = (0, utils_1.useIsMobile)();
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    var ChevronIcon = isOpen ? react_feather_1.ChevronUp : react_feather_1.ChevronDown;
    return (react_1.default.createElement(Wrapper, { className: className },
        react_1.default.createElement(CustomButton, __assign({ variant: variant, size: size, loading: loading, shortcut: shortcut }, props, { disabled: loading || props.disabled }), children),
        react_1.default.createElement(DropdownToggle, { variant: variant, loading: loading, disabled: loading || props.disabled, secondaryThemeColor: secondaryThemeColor, onClick: function () { return setOpen(function (isOpen) { return !isOpen; }); } },
            react_1.default.createElement(ChevronIcon, { color: props.disabled
                    ? theme_1.theme.colors.gray200
                    : variant === "primary"
                        ? secondaryThemeColor
                        : theme_1.theme.colors.gray900, size: 16 })),
        react_1.default.createElement(DropdownMenu_1.DropdownMenu, { isOpen: isOpen && !isMobile, setOpen: setOpen }, menu),
        react_1.default.createElement(ActionSheet_1.ActionSheet, { isOpen: isOpen && isMobile, setOpen: setOpen }, menu)));
};
exports.DropdownButton = DropdownButton;
var Wrapper = (0, styled_1.default)(UIComponents_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  position: relative;\n"], ["\n  display: inline-flex;\n  position: relative;\n"])));
var CustomButton = (0, styled_1.default)(KeyboardButton_1.KeyboardButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 8px 0 0 8px;\n  width: 100%;\n\n  &:hover:not(:disabled) {\n    &::after {\n      border-radius: 8px 0 0 8px;\n    }\n  }\n\n  &:not(:disabled)::after {\n    border-radius: 8px 0 0 8px;\n  }\n"], ["\n  border-radius: 8px 0 0 8px;\n  width: 100%;\n\n  &:hover:not(:disabled) {\n    &::after {\n      border-radius: 8px 0 0 8px;\n    }\n  }\n\n  &:not(:disabled)::after {\n    border-radius: 8px 0 0 8px;\n  }\n"])));
var DropdownToggle = styled_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  width: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 0 8px 8px 0;\n  position: relative;\n  margin-left: -1px;\n\n  &:disabled {\n    ", "\n  }\n\n  &:hover:not(:disabled) {\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: ", ";\n      mix-blend-mode: overlay;\n      opacity: 0.22;\n      border-radius: 0 8px 8px 0;\n    }\n  }\n\n  ", ";\n"], ["\n  border: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  width: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 0 8px 8px 0;\n  position: relative;\n  margin-left: -1px;\n\n  &:disabled {\n    ", "\n  }\n\n  &:hover:not(:disabled) {\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: ", ";\n      mix-blend-mode: overlay;\n      opacity: 0.22;\n      border-radius: 0 8px 8px 0;\n    }\n  }\n\n  ", ";\n"])), function (_a) {
    var loading = _a.loading;
    return loading
        ? "cursor: wait;"
        : "\n            background: ".concat(theme_1.theme.colors.gray200, ";\n            color: ").concat(theme_1.theme.colors.gray400, ";\n            cursor: default;\n            box-shadow: none;\n          ");
}, theme_1.theme.colors.black, function (_a) {
    var secondaryThemeColor = _a.secondaryThemeColor;
    return (0, styled_system_1.variant)({
        prop: "variant",
        variants: {
            primary: {
                bg: "primary",
                color: secondaryThemeColor,
                borderLeft: "1px solid rgba(241, 242, 243, 0.24)",
            },
            secondary: {
                bg: "white",
                color: "gray800",
                boxShadow: "inset 0px 0px 0px 1px ".concat(theme_1.theme.colors.gray400),
                "&:hover": {
                    bg: "gray200",
                },
                "&:not(:disabled)::after": {
                    content: '""',
                    inset: 0,
                    position: "absolute",
                    boxShadow: "0px 0.5px 1px #0000001F",
                    borderRadius: "0 8px 8px 0",
                },
            },
        },
    });
});
var templateObject_1, templateObject_2, templateObject_3;
